import { BaseCriteria } from "../../support/base-criteria.model";

export class GetPackageGroupsModel extends BaseCriteria {

  public PackageId: number;
}

